import React, { PropsWithChildren } from 'react';
import { Container } from './list.style';

export const List: React.FC<PropsWithChildren> = ({ children }) => {
  return <Container>{children}</Container>;
};
